<h2 class="dlg-hndgs">{{title}}</h2>
<p class="dlg-prgrph"> {{message}}</p>

<div *ngIf="showInput" class="input-section" style="margin: 15px 0;">
  <textarea
    [(ngModel)]="inputValue"
    [placeholder]="inputPlaceholder"
    rows="3"
    style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px; resize: vertical; font-family: inherit; font-size: 14px;"
  ></textarea>
</div>

<br *ngIf="!showInput"/>
<mat-dialog-actions class="cncl-ordr-sctin" style="text-align:center">
  <button *ngIf="noButton" mat-button (click)="onCancel()" class="no-delete btn-danger">No</button>
  <button class="btn-success" mat-raised-button (click)="onConfirm()" cdkFocusInitial>
    Yes
  </button>
</mat-dialog-actions>
